import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';

const RoleBasedRoute = ({ children, requiredRole = 'ROLE_ADMIN' }) => {
  return (
    <PrivateRoute>
      <RoleCheck requiredRole={requiredRole}>
        {children}
      </RoleCheck>
    </PrivateRoute>
  );
};

const RoleCheck = ({ children, requiredRole }) => {
  const { user, auth_token } = useSelector((state) => state.auth);
  
  // Check sessionStorage as fallback
  const sessionAuthToken = sessionStorage.getItem('auth_token');
  const sessionUserStr = sessionStorage.getItem('user');
  const sessionUser = sessionUserStr ? JSON.parse(sessionUserStr) : null;
  
  const hasAuth = auth_token || sessionAuthToken;
  const currentUser = user || sessionUser;
  
  if (!hasAuth) {
    return <Navigate to="/login" />;
  }

  if (!currentUser || currentUser.role !== requiredRole) {
    return <Navigate to="/report" />;
  }

  return children;
};

export default RoleBasedRoute;

